export default "__VITE_ASSET__Bydryx$q__"